import React, { useState, useEffect } from "react";
import { FaPlus, FaTrash, FaEdit } from "react-icons/fa";

export default function Lists() {
    const [tasks, setTasks] = useState([]);
    const mainColorStyle = { backgroundColor: "var(--main-color)" };

    // Load tasks from localStorage when the component mounts
    useEffect(() => {
        const savedTasks = localStorage.getItem("tasks");
        if (savedTasks) {
            setTasks(JSON.parse(savedTasks));
        }
    }, []);

    // Save tasks to localStorage whenever tasks state changes
    useEffect(() => {
        localStorage.setItem("tasks", JSON.stringify(tasks));
    }, [tasks]);

    const addNewTask = () => {
        setTasks([...tasks, { id: Date.now(), title: "", isEditing: true }]);
    };

    const handleInputChange = (e, taskId) => {
        setTasks(
            tasks.map((task) =>
                task.id === taskId ? { ...task, title: e.target.value } : task
            )
        );
    };

    const handleNotifyMe = (taskId) => {
        setTasks(
            tasks.map((task) =>
                task.id === taskId ? { ...task, isEditing: false } : task
            )
        );
    };

    const handleEditTask = (taskId) => {
        setTasks(
            tasks.map((task) =>
                task.id === taskId ? { ...task, isEditing: true } : task
            )
        );
    };

    const handleDeleteTask = (taskId) => {
        setTasks(tasks.filter((task) => task.id !== taskId));
    };

    return (
        <>
            <div className="flex flex-wrap ml-5 sm:ml-0 justify-center sm:justify-start">
                {tasks.map((task) => (
                    <div
                        key={task.id}
                        className="relative w-64 h-64 rounded overflow-hidden bg-white border border-gray-300 mb-4 flex flex-col justify-between p-4 mx-2 sm:mr-5">
                        {task.isEditing ? (
                            <input
                                type="text"
                                className="border p-2 rounded w-full mb-2"
                                value={task.title}
                                onChange={(e) => handleInputChange(e, task.id)}
                                placeholder="Enter task"
                            />
                        ) : (
                            <p className="text-gray-700 text-base">
                                {task.title}
                            </p>
                        )}
                        <div className="flex space-x-2 mt-2">
                            <button
                                className="text-black py-2 px-4 rounded"
                                style={mainColorStyle}
                                onClick={() => handleNotifyMe(task.id)}>
                                Save
                            </button>
                            {!task.isEditing && (
                                <FaEdit
                                    className="text-gray-700 cursor-pointer absolute bottom-6 right-16"
                                    onClick={() => handleEditTask(task.id)}
                                />
                            )}
                            <FaTrash
                                className="text-gray-700 cursor-pointer absolute bottom-6 right-6"
                                onClick={() => handleDeleteTask(task.id)}
                            />
                        </div>
                    </div>
                ))}
                <div
                    className="w-64 h-64 rounded overflow-hidden bg-white border border-gray-300 mb-4 flex flex-col justify-center items-center cursor-pointer mx-2 sm:mr-5"
                    onClick={addNewTask}>
                    <FaPlus size={35} className="text-gray-700" />
                    <p className="text-gray-700 text-base mt-2">Add Task</p>
                </div>
            </div>
        </>
    );
}
